import React from 'react';
import { FiGlobe, FiFileText, FiCheckCircle, FiEdit3 } from 'react-icons/fi';
import styles from './Dashboard.module.css';

const iconMap = {
    'Total Sites': FiGlobe,
    'Total Submissions': FiFileText,
    'Completed': FiCheckCircle,
    'Drafts': FiEdit3,
};

const StatCard = ({ stat }) => {
    const Icon = iconMap[stat.title];

    return (
        <div className={styles.statCard}>
            <div className={styles.statIcon} style={{ backgroundColor: `${stat.color}15`, color: stat.color }}>
                <Icon />
            </div>
            <div className={styles.statContent}>
                <h3 className={styles.statTitle}>{stat.title}</h3>
                <p className={styles.statValue}>{stat.value}</p>
                {stat.change && <p className={styles.statChange}>{stat.change}</p>}
            </div>
        </div>
    );
};

export default StatCard;